/**
 * Cliente para o feed publico do Instagram da EnQ Digital, servido pela rota
 * interna /api/instagram (que fala com a Instagram Graph API server-side, com o
 * token guardado no .env). Sem credenciais aqui: e conteudo publico.
 *
 * Segue o mesmo espirito de src/lib/blog-api.ts.
 */

export type InstagramMediaType = 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM';

export interface InstagramMedia {
  id: string;
  /** Legenda do post; pode vir vazia. */
  caption: string;
  mediaType: InstagramMediaType;
  /** URL da midia na CDN da Meta - ASSINADA E TEMPORARIA, nunca re-hospedar. */
  mediaUrl: string | null;
  /** Miniatura para itens de video; ausente em imagens. */
  thumbnailUrl: string | null;
  /** Link canonico do post no Instagram - e para ca que os cards apontam. */
  permalink: string;
  /** ISO 8601 (ex.: 2026-08-29T12:34:56+0000). */
  timestamp: string;
  /** media_product_type === 'REELS'. */
  isReel: boolean;
}

/**
 * Busca as ultimas midias. Qualquer falha (rede, token ausente, erro da Meta)
 * degrada para lista vazia - a pagina /midia nunca quebra por causa disso,
 * mesmo criterio do sitemap.ts.
 */
export async function listarMidiasInstagram(limite = 12): Promise<InstagramMedia[]> {
  try {
    const res = await fetch(`/api/instagram?limite=${limite}`);
    if (!res.ok) return [];
    const data = await res.json().catch(() => ({}));
    return Array.isArray(data.midias) ? (data.midias as InstagramMedia[]) : [];
  } catch {
    return [];
  }
}

const LOCALE_DATE: Record<string, string> = {
  pt: 'pt-BR',
  en: 'en',
  es: 'es',
};

/** Data legivel para o locale atual (ex.: "29 de agosto de 2026"). */
export function dataInstagram(iso: string | null, locale = 'pt'): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(LOCALE_DATE[locale] ?? 'pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
